import { ScrollText } from "lucide-react";
import { useGame } from "../../state/GameProvider";

export function BattleLog({ compact = false }: { compact?: boolean }) {
  const { state } = useGame();
  return (
    <div className={`battlelog${compact ? " compact" : ""}`}>
      <div className="battlelog-head">
        <ScrollText size={13} />
        戰鬥日誌
      </div>
      {state.log.slice(0, compact ? 3 : 6).map((entry) => (
        <p key={entry.id} className={`battlelog-line ${entry.tone}`}>
          {entry.text}
        </p>
      ))}
    </div>
  );
}
